export default "__VITE_ASSET__DbgLnQ5f__"